"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _FormControls = require("../../FormControls");
var _semanticUiReact = require("semantic-ui-react");
var _utils = require("../../../../../common/utils");
var _endpoints = require("../../../../../common/endpoints");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var emailErrorMsg = 'You must use a valid Email address';
var femaErrorMsg = ['FEMA users are required to use their PIV card for authentication.  Instead of registering, please ', /*#__PURE__*/_react.default.createElement("a", {
  href: "".concat(_endpoints.ENDPOINT_SAML, "saml/authenticate")
}, "sign in with your PIV credentials"),
// do not ever change this endpoint from auth/api/v1/ or this will break
'.'];
var confirmEmailError = 'You must use a valid Email address and Confirmation Email must match.';
var EmailForm = /*#__PURE__*/function (_React$Component) {
  _inherits(EmailForm, _React$Component);
  var _super = _createSuper(EmailForm);
  function EmailForm(props) {
    var _this;
    _classCallCheck(this, EmailForm);
    _this = _super.call(this, props);
    _this.setEmailValidationError = function (msg) {
      return _this.setState({
        emailError: true,
        errorMessage: msg,
        formHasErrors: true
      }, _this.props.setFormHasErrors);
    };
    _this.checkMatchingEmails = function (email, confirmEmail) {
      if (email.toLowerCase() !== confirmEmail.toLowerCase()) {
        _this.setEmailValidationError(confirmEmailError);
      } else {
        _this.resolveEmailValidationError();
      }
    };
    _this.resolveEmailValidationError = function () {
      return _this.setState({
        formHasErrors: false,
        emailError: false,
        errorMessage: ''
      }, function () {
        _this.props.setEmail(_this.state.email);
      });
    };
    _this.handleChange = function (e) {
      var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
      _this.setState(_defineProperty({}, name, value));
    };
    _this.handleEmailBlur = function (e) {
      var value = e.target.value;
      _this.handleBlur(value);
    };
    /* TODO clean up this blob */
    _this.handleBlur = function (email) {
      var confirmEmailValidation = _this.props.confirmEmailValidation;
      if (!(0, _utils.checkIfEmailIsValid)(email)) {
        _this.setEmailValidationError(emailErrorMsg);
      } else {
        if (!(0, _utils.checkIfEmailIsFEMA)(email)) {
          if (confirmEmailValidation) {
            _this.checkMatchingEmails(email, confirmEmailValidation);
          } else {
            _this.resolveEmailValidationError();
          }
        } else {
          _this.setEmailValidationError(femaErrorMsg);
        }
      }
    };
    _this.state = {
      email: '',
      formHasErrors: true,
      errorMessage: '',
      emailError: false,
      firstVisit: true
    };
    return _this;
  }

  /* TODO redo this to use getDerivedStateFromProps */
  _createClass(EmailForm, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var confirmEmailValidation = this.props.confirmEmailValidation;
      if (confirmEmailValidation !== undefined && nextProps.confirmEmailValidation !== confirmEmailValidation) {
        if (!this.state.firstVisit) {
          this.checkMatchingEmails(this.state.email, nextProps.confirmEmailValidation);
        } else {
          this.setState({
            firstVisit: false
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        errorMessage = _this$state.errorMessage,
        email = _this$state.email;
      var label = this.props.label ? this.props.label : 'Email';
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement(_FormControls.TextBoxField, {
        value: email,
        label: label,
        id: "email",
        title: 'Required: ' + label,
        name: "email",
        displayError: this.state.emailError,
        handleChange: this.handleChange,
        handleBlur: this.handleEmailBlur,
        maxLength: 101,
        errorMessages: errorMessage
      })));
    }
  }]);
  return EmailForm;
}(_react.default.Component);
exports.default = EmailForm;